import React from "react";
import { Route } from "react-router-dom";
import useDashboardPermissions from "../hooks/useDashboardPermissions";

const PermissionDeniedMessage = () => (
  <div className="flex align-items-center justify-content-center p-6">
    <p className="text-color-secondary m-0">
      Você não tem permissão para acessar esta página.
    </p>
  </div>
);

const DashboardRouter = ({ routers, userTypeInfo }) => {
  useDashboardPermissions(userTypeInfo);

  return (
    <>
      {routers.map((router, index) => {
        const hasAccess =
          !router.hasPermissionPlans ||
          userTypeInfo == null ||
          router.hasPermissionPlans.includes(userTypeInfo);
        const Component = hasAccess
          ? router.component
          : () => <PermissionDeniedMessage />;
        return (
          <Route
            key={`router${index}`}
            path={router.path}
            component={Component}
            exact={router?.exact ? router.exact : false}
          />
        );
      })}
    </>
  );
};

export default DashboardRouter;
